import api from "./api";

const getCourseModules = (id) => {
  return api.get(`api/courseModules/user/${id}`);
};

const createCourseModules = (data) => {
  return api.post(`api/courseModules`, data);
};

const getUsersCourseModules = (id) => {
  return api.get(`api/usuarioCurso/buscaUsuarioCurso/${id}`);
};

const getUsersCourseModulesAndTopics = (id, idTopic) => {
  return api.get(`api/usuarioCurso/buscaUsuarioCurso/${id}/${idTopic}`);
};

// Backoffice: cursos e módulos comprados por um usuário, com status e conclusão.
const getUserPurchases = (userId) => {
  return api.get(`api/usuarioCurso/comprasUsuario/${userId}`);
};

// Backoffice: ativa/inativa a inscrição em um curso (usuario_curso).
const updateEnrollmentStatus = (id, fg_ativo) => {
  return api.put(`api/usuarioCurso/status/${id}`, { fg_ativo });
};

// Backoffice: ativa/inativa um módulo comprado (course_module).
const updateModuleStatus = (id, fg_ativo) => {
  return api.put(`api/courseModules/status/${id}`, { fg_ativo });
};

export {
  getCourseModules,
  createCourseModules,
  getUsersCourseModules,
  getUsersCourseModulesAndTopics,
  getUserPurchases,
  updateEnrollmentStatus,
  updateModuleStatus
};
